import React, { useState, useEffect } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import SlaReport from "./SlaReport";
import CustomReport from "./CustomReport";
import CurrentStatusReport from "./CurrentStatusReport";
import DetailsReport from "./DetailsReport";
import { useDispatch, useSelector } from 'react-redux';
import { setTabViewType, } from "./reportSlice";

export const ReportsView = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const jobState = useSelector((state) => state.job);
  const reportState = useSelector((state) => state.reports);
  const {
    tabViewType,
  } = reportState;
  const {
    appLanguage,
  } = jobState;
  const dispatch = useDispatch();
  const handleTabChange = (index) => {
    // console.log(index, "indexindexindex");
    dispatch(setTabViewType(index));
    // setActiveIndex(index);
  };

  return (
    <div className="cards job-view-wrap reporting-sla-wrap">
      <div className="tab-wrap">
        <TabView activeIndex={tabViewType} onTabChange={(e) => handleTabChange(e.index)}>
          <TabPanel header={appLanguage["report.header.label.sla"]}>
            <SlaReport />
          </TabPanel>

          <TabPanel header={appLanguage["report.header.label.custom"]}>
            <CustomReport />
          </TabPanel>

          <TabPanel header={appLanguage["report.header.label.current-status"]}>
            <CurrentStatusReport />
          </TabPanel>

          <TabPanel header={appLanguage["report.header.label.details"]}>
            <DetailsReport />
          </TabPanel>

        </TabView>
        {/* <hr className="footer-border" /> */}
      </div>
    </div>
  );
}
